<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="section" v-on:click="goTo('/companies')">Compañías</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Editar Compañía</a>
  </div>
  <h1 class="ui header"><i class="icon building"></i><div class="content">Editar Compañía</div></h1>
  <button class="ui basic button rightButton" v-on:click="goTo('/companies')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <div v-if="!selectedCompany" class="ui active centered inline loader"></div>
  <div v-if="selectedCompany" class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <form class="ui form" @submit.prevent="editCompany">
          <h4 class="ui dividing header">Información de la compañía</h4>
          <div class="inline field">
            <sui-checkbox label="Activo" toggle v-model="selectedCompany.active" />
          </div>
          <div class="field">
            <label>Nombre *</label>
            <input type="text" v-model="selectedCompany.name" placeholder="Nombre" required>
          </div>
          <div class="field">
            <label>Imagen de la Compañía</label>
            <input type="file" accept="image/*" @change="onFilePicked">
            <img v-if="selectedCompany.image_url" class="ui medium image" :src="selectedCompany.image_url">
            <img v-if="!selectedCompany.image_url" class="ui medium image" src="../../assets/name.png">
          </div>
          <div class="field">
            <label>Descripción</label>
            <textarea rows="4" maxlength="200" v-model="selectedCompany.description"></textarea>
          </div>
          <div class="field">
            <label>External name *</label>
            <input type="text" v-model="selectedCompany.external_name" placeholder="External name" required>
          </div>
          <div class="field">
              <label>Tema del Admin</label>
              <sui-dropdown placeholder="Tema" search selection :options="adminThemeOptions" v-model="selectedCompany.admin_theme_id" required />
          </div>
          <div class="two fields">
            <div class="field">
              <label>Creado</label>
              <input type="text" v-model="selectedCompany.created" readonly>
            </div>
            <div class="field">
              <label>Modificado</label>
              <input type="text" v-model="selectedCompany.modified" readonly>
            </div>
          </div>
          <button class="ui button" type="submit">Editar</button>
          <div class="ui red button eskubian" v-on:click="deleteCompany()">Eliminar</div>
        </form>
      </div>
      <div class="column">
        <h4 class="ui dividing header">Lista de usuarios de la compañía<div class="hapiick eskubian">Activo</div></h4>
        <div class="ui relaxed divided list">
          <div class="item" v-for="user in users" v-bind:key="user.id">
            <img class="ui mini image" src="../../assets/user.png">
            <div class="content">
              <a class="header" v-on:click="goTo('/users/edit/' + user.id)">{{user.username}}</a>
              <div class="description">{{user.name}}</div>
            </div>
            <div class="right floated content"><i v-if="user.active" class="hapiick check icon"></i><i v-if="!user.active" class="red times icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'editCompany',
  props: ['id'],
  data() {
    return {
      selectedCompany: null,
      users: null,
      adminThemeOptions: [],
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if(role === 'master' || role === 'admin'){
      this.getCompany()
      this.getDataFilters()
    }else{
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    async getCompany() {
      await hapiickApi().post('/v1/companies/get-company', {
        admin_id: JSON.parse(localStorage.admin).id,
        company_id: this.id
      })
      .then(request => {
        this.updateEditCompany(JSON.parse(JSON.stringify(request.data.data.company)))
      })
      .catch(() => console.log('error getting company'))
    },
    editCompany() {
      hapiickApi().post('/v2/companies/edit', {
        admin_id: JSON.parse(localStorage.admin).id,
        companyData: this.selectedCompany,
      })
      .then(request => this.companySaved(request))
      .catch(() => this.$swal({
        type: 'error',
        title: 'Error',
        text: 'No se han podido guardar los datos'
      }))
    },
    onFilePicked(event) {
      const files = event.target.files
      let filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.selectedCompany.image = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
    },
    goTo(where) {
      this.$router.push(where)
    },
    updateEditCompany(req) {
      this.selectedCompany = req.AdminCompany
      this.users = req.Administrator
    },
    companySaved(req) {
      if (req.data.status !== 'OK') {
        this.$swal({
          type: 'error',
          title: 'Error',
          text: 'No se han podido guardar los datos'
        })
      }
      this.$swal({
        type: 'success',
        title: 'Los datos se han guardado correctamente',
        showConfirmButton: false,
        timer: 2500
      })
      this.goTo('/companies')
    },
    deleteCompany() {
      this.$swal({
        title: '¿Estas seguro?',
        text: "¡Si lo eliminas no podrás recuperar los datos!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '¡Si, eliminar!'
      }).then((result) => {
        if (result.value) {
          hapiickApi().post('/v2/companies/delete', {
            admin_id: JSON.parse(localStorage.admin).id,
            company_id: this.id,
            image_url: this.selectedCompany.image_url
          })
          .then(request => this.eliminar(request))
          .catch(() => this.$swal(
            'Error!',
            'No se han podido eliminar los datos',
            'error'
          ))
        }
      })
    },
    eliminar(req) {
      if (req.data.status !== 'OK') {
        this.$swal({
          type: 'error',
          title: 'Error',
          text: 'No se han podido eliminar los datos'
        })
      }
      this.$swal({
        type: 'success',
        title: 'Eliminado!',
        text: 'Los datos se han eliminado correctamente',
        showConfirmButton: false,
        timer: 2500
      })
      this.goTo('/companies')
    },
    async getDataFilters() {
      await hapiickApi().post('/v2/shipments/filters', {
        admin_id: JSON.parse(localStorage.admin).id,
        AdminTheme: true
      })
      .then(request => {
        this.fillAdminThemeOptions(JSON.parse(JSON.stringify(request.data.data.adminTheme)))
      })
      .catch(() => console.log('error getting combo filters'))
    },
    fillAdminThemeOptions(adminTheme) {
      for (let i = 0; i < adminTheme.length; i++) {
        this.adminThemeOptions.push({
          text: adminTheme[i].AdminTheme.name,
          value: adminTheme[i].AdminTheme.id,
          id: adminTheme[i].AdminTheme.id
        })
      }
    },
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Companies/editCompany.vue